// home page featured collection grid add to cart button

$(document).ready(function () {
    // Attach click event to the Add to Cart button
    $(document).on('click', '.custom_add_to_cart', function (e) {
      e.preventDefault(); // Prevent default button behavior

      // Retrieve the product variant ID from the data attribute
      const productId = $(this).data('product-id');

      // Check if product ID is valid
      if (!productId) {
        alert('Product ID is missing. Unable to add product to cart.');
        console.error('Error: Product ID is missing.');
        return;
      }

      // AJAX request to add the product to the cart
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({
          id: productId, // Shopify product variant ID
          quantity: 1,   // Quantity to add
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: function (response) {
          console.log('Product added to cart:', response);
          // Redirect to the cart page after successfully adding the product
          window.location.href = '/cart';
        },
        error: function (xhr, status, error) {
          console.error('Error adding product to cart:', xhr.responseText);
          alert('Failed to add product to cart. Please try again.');
        },
      });
    });
  });

// start add to cart button js

document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector('.product-form__cart-submit');
  
  // Check if the button exists before proceeding
  if (!addToCartButton) return;

  // Create the sticky button
  const stickyButton = document.createElement('div');
  stickyButton.classList.add('sticky-add-to-cart');
  stickyButton.innerHTML = addToCartButton.outerHTML; // Copy the Add to Cart button's content
  document.body.appendChild(stickyButton);
  
  // Style the sticky button
  stickyButton.style.position = 'fixed';
  stickyButton.style.bottom = '0';
  stickyButton.style.left = '0';
  stickyButton.style.width = '100%';
  stickyButton.style.zIndex = '9999';
  stickyButton.style.display = 'none';  // Initially hidden
  
  let lastScrollTop = 0;

  window.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY;
    const addToCartButtonRect = addToCartButton.getBoundingClientRect();
    
    // Show sticky button when scrolling down and original button is not visible
    if (scrollPosition > lastScrollTop) {
      if (addToCartButtonRect.bottom < 0) {
        stickyButton.style.display = 'block';
      }
    } else {
      // Hide sticky button when scrolling up and original button is visible
      if (addToCartButtonRect.bottom > 0) {
        stickyButton.style.display = 'none';
      }
    }
    
    lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
  });
});

// end add to cart button js

